
<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>

<div *ngIf="!containsError">
  <div class="pageHeader" >Delete Loan Confirmation</div>

  <div class="appr-del-msg" *ngIf="deleteFlag">

    <span>
      The following transactions have been deleted successfully.
    </span>

  </div>

  <div class="appr-del-msg"  *ngIf="!deleteFlag">

    <span>Do you really want to delete the transactions?</span>
  </div>

  <div *ngIf="selectedTransactionsList" class="u-scroll-x">
    <fm-table [columns]="cols" [value]="selectedTransactionsList"
              [paginator]="true" [rows]="10"
              [compressed]="true" [autoLayout]="true"
              [rowsPerPageOptions]="[10,25,50]" [enableTableEntryTotal]="true">
      <ng-template fmTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" class="row-selection">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template fmTemplate="body" let-rowData let-columns="columns">
        <tr>
          <td class="td-content" *ngFor="let col of columns">

            <span>{{rowData[col.field]}}</span>

          </td>
        </tr>
      </ng-template>
    </fm-table>
  </div>
  <span></span>

  <div class="u-mb-150" *ngIf="!deleteFlag" >
    <button fmButton type="submit" [primary]="true" [small]="true" label="Yes"
            (click)="confirmDelete()" class="buttonmargin"></button>

    <button fmButton type="button" (click)="cancelButton()" [primary]="true" label="No" [small]="true" class="buttonmargin"></button>
  </div>

</div>
